import { isTopic } from '@tunein/web-common';

export const FETCH_PROFILE = 'FETCH_PROFILE';
export const FETCH_TOPIC_PROFILE = 'FETCH_TOPIC_PROFILE';
export const SET_BRAZE_PROFILE_CARDS = 'SET_BRAZE_PROFILE_CARDS';

export function fetchProfileEffect({ guideId, itemToken }, type, categoryToPrepend) {
  return {
    type,
    api: {
      endpoint: ['ui', 'get'],
      args: [{ guideId, params: { itemToken } }],
      isWACBeta: true,
    },
    meta: {
      contentId: guideId,
      categoryToPrepend,
    },
  };
}

// exported for testing
export function fetchTopicEffect({ guideId, apiOptions }) {
  if (isTopic(guideId)) {
    return {
      type: FETCH_TOPIC_PROFILE,
      api: {
        endpoint: ['ui', 'get'],
        args: [{ guideId }],
        isWACBeta: true,
        ...apiOptions,
      },
      meta: {
        contentId: guideId,
      },
    };
  }

  return null;
}

export function fetchTopicData(guideId) {
  // NOTE: we don't want API failures for topic fetches to generate app errors (e.g. resulting in
  // 404/500 pages), so disabling them here.
  return fetchTopicEffect({ guideId, apiOptions: { registerAppError: false } });
}

export function fetchProfile(guideItem, categoryToPrepend) {
  return fetchProfileEffect(guideItem, FETCH_PROFILE, categoryToPrepend);
}

export function setBrazeProfileCards(guideId, brazeCards) {
  return {
    type: SET_BRAZE_PROFILE_CARDS,
    meta: {
      guideId,
      brazeCards,
    },
  };
}
